import { z } from 'zod';

export const driverStatusSchema = z.enum(['active', 'inactive', 'busy', 'pending', 'blocked']);
/**
 * the driver status:
 * - `active` = means the driver is ready to accept orders.
 * - `inactive` = means the driver has turned off the app, and does not want to accept order.
 * - `busy` = means the driver is currently delivering an order.
 * - `blocked` = means that the driver has been blocked by The platform and cannot turn on to be active.
 */
export type DriverStatus = z.infer<typeof driverStatusSchema>;
